<template>
  <div class="login">
    <topmytitle :title1="titlework" />
    <p class="text-tip">为了保护您的隐私，请进行安全验证</p>
    <van-form style="margin: 10px 0">
      <van-field
        v-model="password"
        type="password"
        name="密码"
        label="密码"
        placeholder="密码"
        style="margin-top: 10px"
        autocomplete="off"
        :rules="[{ required: true, message: '请填写密码' }]"
      />
    </van-form>
    <div class="button-bt">
      <div @click="submit">提交</div>
      <!-- <div @click="goBack">返回</div> -->
    </div>
    <p class="text-tip">（薪酬异动查询密码与薪资查询密码相同）</p>
    <p class="forgetpw" @click="resetPwd">忘记密码？</p>

    <van-dialog
      v-model="showReset"
      title="忘记密码"
      @confirm="handleConfirm"
      show-cancel-button
    >
      <van-form ref="myform">
        <van-field
          v-model="mobilePhone"
          label="手机号"
          placeholder="请输入手机号"
          :disabled="true"
        />
        <van-field
          v-model="smscode"
          center
          clearable
          label="验证码"
          :rules="[{ required: true, message: '请填写验证码' }]"
          placeholder="请输入验证码"
        >
          <template #button>
            <van-button size="small" type="info" @click="gainCode">{{
              countDown
            }}</van-button>
          </template>
        </van-field>
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
  import { Toast } from 'vant';
  import topmytitle from '../components/topmytitle';
  import {
    GetMyPwdDataApi,
    smsPhonePwdDataApi,
    forgetPwdDataApi
  } from '../request/api';
  //import { urlEncode, string2Base64 } from '../utils/index'
  export default {
    data() {
      name: 'Login';
      return {
        titlework: '二次验证',
        password: '',
        showReset: false,
        isClick: true,
        smscode: '',
        mobilePhone: '',
        countDown: '获取验证码',
        infoId: ''
      };
    },
    computed: {},
    methods: {
      //获取验证码
      async gainCode() {
        let params = {
          EMPLID: sessionStorage.getItem('EMPLID'),
          MOBILE_PHONE: this.mobilePhone
        };
        // 获取验证码接口
        smsPhonePwdDataApi(params).then(res => {
          if (res.CODE === 200) {
            this.$toast('短信发送成功');

            let stime = 60;
            this.countDown = stime + 's';
            var interval = setInterval(() => {
              stime--;
              this.countDown = stime + 's';
              if (stime <= 0) {
                this.countDown = '重新获取';

                clearInterval(interval);
              }
            }, 1000);
          } else {
            this.$toast(res.MESSAGE);
            this.countDown = '重新获取';
            clearInterval(interval);
          }
        });
      },
      //
      handleConfirm() {
        this.$refs['myform'].validate().then(() => {
          let params = {
            EMPLID: sessionStorage.getItem('EMPLID'),
            MOBILE_PHONE: this.mobilePhone,
            SMSCODE: this.smscode
          };
          forgetPwdDataApi(params).then(res => {
            if (res.CODE === 200) {
              Toast.success(res.MESSAGE);
              this.$router.push({
                path: '/changepwd'
              });
            } else {
              Toast.fail(res.MESSAGE);
            }
          });
        });
      },
      //提交密码登录
      submit() {
        let params = {
          EMPLID: sessionStorage.getItem('EMPLID'),
          PASSWORD: this.password
        };
        GetMyPwdDataApi(params).then(res => {
          if (res.CODE === 200) {
            if (res.DATA.FLAG === 'N') {
              this.$dialog
                .alert({
                  title: '温馨提示',
                  message:
                    '您当前密码为初始密码，为保护您的隐私请先设置新密码后查看'
                })
                .then(() => {
                  // on close
                  this.$router.push({
                    path: '/changepwd'
                  });
                });
            } else {
              Toast.success(res.MESSAGE);
              if (this.infoId) {
                //跳到工资异动信息
                this.$router.push({
                  path: '/myincomeChange',
                  query: { param: this.password, infoId: this.infoId }
                });
              } else {
                //跳到工资信息
                this.$router.push({
                  path: '/myincome',
                  query: { param: this.password }
                });
              }
            }

            this.$store.commit('setpwdData', this.password);
            // this.$store.commit('setSubBOdy', res.DATA.subBody)
          } else {
            this.password = '';
            Toast.fail(res.MESSAGE);
          }
        });
      },
      resetPwd() {
        this.showReset = true;
      },
      goBack() {
        this.$router.back(-1);
        //this.$router.push('/')
      },
      cleanpassword() {
        this.password = '';
        this.$router.back(-1);
      }
    },
    components: {
      topmytitle
    },
    created() {
      this.mobilePhone = this.$store.state.basicinfo.MOBILE_PHONE;
      this.infoId = this.$route.query.infoId;
    }
  };
</script>
<style lang="less" scoped>
  /deep/ .van-field__label {
    color: black;
    font-weight: bold;
    font-size: 16px;
  }
  .button {
    position: fixed;
    bottom: 0;
    display: flex;
    width: 100%;
    button {
      width: 50%;
      border: 0;
      color: white;
      background: #007fc6;
    }
  }
  /deep/.van-button {
    font-size: 16px;
  }
  .text-tip {
    text-align: center;
    padding: 5px;
    color: #969799;
    font-size: 13px;
  }
  .button-bt {
    position: fixed;
    bottom: 0;
    display: flex;
    line-height: 44px;
    text-align: center;
    color: white;
    width: 100%;
    div {
      background: #007fc6;
      width: 100%;
      font-size: 17px;
    }
  }

  .forgetpw {
    margin: 0 auto;
    font-size: 14px;
    color: #007fc6;
    text-align: center;
    margin-top: 10px;
  }
</style>
